import React from 'react';
import { CcIcon } from '@utp/components-react';

import {
  Wrapper,
  WrapperCard,
  WrapperCards,
  WrapperDescription
} from './styled';

const ProfileCards = () => (
  <Wrapper>
    <WrapperDescription>
      Ahora, puedes gestionar tu información personal y más adelante, podrás
      agregar otros datos para seguir conectados.
    </WrapperDescription>
    <WrapperCards>
      <WrapperCard to={{ pathname: '/perfil/informacion-personal' }}>
        <div>
          <CcIcon size={32} name="user" />
          <h3>Información personal</h3>
          <span>
            Agrega tus datos personales e indícanos como mantenernos en
            contacto.
          </span>
        </div>
        <div>
          <CcIcon size={24} name="chevron-right" />
        </div>
      </WrapperCard>
    </WrapperCards>
  </Wrapper>
);

export default ProfileCards;
